import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {

  GET_ATTACH_INFO_REQUEST: '',
  GET_ATTACH_INFO_SUCCESS: '',
  GET_ATTACH_INFO_FAILURE: '',

  DOWNLOAD_ATTACHMENT_REQUEST: '',
  DOWNLOAD_ATTACHMENT_SUCCESS: '',
  DOWNLOAD_ATTACHMENT_FAILURE: '',

  CHECK_REQUIRED_REQUEST: '',
  CHECK_REQUIRED_SUCCESS: '',
  CHECK_REQUIRED_FAILURE: '',

};

types = setStoreTypeValues(types, 'authAttach');

export default types;
